module.exports = __webpack_public_path__ + "img/warn.12005a63.svg";